/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ groups: NonNullable<unknown> }} Assistant_Restore_Event_LockedInputs */



/**
* | output |
* | --- |
* | "Locked groups were not changed: {groups}" |
*
* @param {Assistant_Restore_Event_LockedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_restore_event_locked = /** @type {((inputs: Assistant_Restore_Event_LockedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Restore_Event_LockedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Les groupes verrouillés n'ont pas été modifiés : ${i?.groups}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Gesperrte Gruppen wurden nicht geändert: ${i?.groups}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`I gruppi bloccati non sono stati modificati: ${i?.groups}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Заблокированные группы не были изменены: ${i?.groups}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Los grupos bloqueados no se modificaron: ${i?.groups}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已锁定的组未更改：${i?.groups}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ロックされたグループは変更されませんでした: ${i?.groups}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`लॉक किए गए समूहों में कोई बदलाव नहीं हुआ: ${i?.groups}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Os grupos bloqueados não foram alterados: ${i?.groups}`)
	return /** @type {LocalizedString} */ (`Locked groups were not changed: ${i?.groups}`)
});